if (!customElements.get("m-recommend-recent-tabs")) {
  class MRecommendRecentTabs extends HTMLElement {
    connectedCallback() {
      this.section = this.closest(".m-section");
      this.headers = Array.from(this.querySelectorAll(".m-tab-header"));
      this.panes = Array.from(this.querySelectorAll("[data-tab-pane]"));
      this.navWrapper = this.querySelector(".m-section__tabs");
      this.populated = new Set();
      this.userInteracted = false;

      if (!this.panes.length) return;

      // Recommendations stays visible and first. Recently viewed waits for products.
      this.headers.forEach((header, index) => {
        if (index === 0) {
          header.classList.remove("m:hidden");
        } else {
          header.classList.add("m:hidden");
        }
      });

      this.initTabs();
      this.activateTab(0);
      this.observePanes();
      this.updateNavVisibility();

      this.settleTimeout = setTimeout(() => this.finalize(), 8000);
    }

    initTabs() {
      if (window.MinimogTheme && MinimogTheme.Tabs) {
        this.tabs = new MinimogTheme.Tabs(this, () => this.refreshActiveSlider());
      }

      this.headers.forEach((header) => {
        header.addEventListener("click", () => {
          this.userInteracted = true;
        });
      });
    }

    paneHasProducts(pane) {
      return !!pane && pane.querySelectorAll(".m-product-card").length > 0;
    }

    observePanes() {
      this.panes.forEach((pane, index) => {
        if (this.paneHasProducts(pane)) {
          this.markPopulated(index);
          return;
        }
        const observer = new MutationObserver(() => {
          if (this.paneHasProducts(pane)) {
            observer.disconnect();
            this.markPopulated(index);
          }
        });
        observer.observe(pane, { childList: true, subtree: true });
      });
    }

    markPopulated(index) {
      if (this.populated.has(index)) return;
      this.populated.add(index);

      this.headers[index] && this.headers[index].classList.remove("m:hidden");
      this.updateNavVisibility();

      // Recommendations remains the default active tab.
      if (!this.userInteracted) {
        this.activateTab(0);
      } else {
        this.refreshActiveSlider();
      }
    }

    activateTab(index) {
      if (!this.tabs) return;
      this.tabs.setActiveTab(index);
      this.refreshActiveSlider();
    }

    refreshActiveSlider() {
      const active = this.querySelector(".m-tab-content.active");
      if (!active) return;
      const update = () => {
        active.querySelectorAll(".swiper-container").forEach((el) => {
          el.swiper && el.swiper.update();
        });
        const recently = active.querySelector("m-recently-viewed");
        if (recently && typeof recently.positionControls === "function") {
          recently.positionControls();
        }
      };
      requestAnimationFrame(() => {
        update();
        setTimeout(update, 50);
        setTimeout(update, 250);
      });
    }

    updateNavVisibility() {
      if (!this.navWrapper) return;
      const visible = this.headers.filter((header) => !header.classList.contains("m:hidden"));
      this.navWrapper.style.display = "";
      this.navWrapper.classList.toggle("m-section__tabs--single", visible.length < 2);
    }

    finalize() {
      if (this.populated.size === 0) {
        this.section && this.section.classList.add("m:hidden");
      }
    }
  }

  customElements.define("m-recommend-recent-tabs", MRecommendRecentTabs);
}
